import { FC } from 'react'
import styled from '@emotion/styled'
import { ModalCard } from 'src/v2/views/owner-reveal/insights/parcels/parcel-modal/modal-card'
import { DescriptionItem } from 'src/v2/components/description-item'
import * as atoms from 'src/v2/state/owner-reveal/entity-parcels'
import { useAtomValue } from 'jotai'
import { prettyNumber } from 'src/utils/number-format'
import { useGetParcelLinks } from 'src/v2/hooks/use-get-parcel-links'

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

const Row = styled.div`
  display: flex;
  gap: 16px;
  width: 100%;
`
const Column = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`

export const BuildingAndLotCard: FC = () => {
  const data = useAtomValue(atoms.selectedParcelPropertyRecords)
  const parcel = useAtomValue(atoms.selectedParcel)
  const buildingAndLot = data?.buildingAndLot
  const { getParcelLinks, notFound: disableActionButton } = useGetParcelLinks(parcel)

  const openPropertyRecordsPage = async () => {
    const links = await getParcelLinks()
    if (links?.propertyRecordsLink) {
      window.open(links.propertyRecordsLink, '_blank')
    }
  }

  return (
    <ModalCard
      title="Building & Lot"
      actionText="Property Records"
      onActionClick={openPropertyRecordsPage}
      actionDisabled={disableActionButton}>
      <Content>
        <Row>
          <Column>
            <DescriptionItem label="Year Built" value={buildingAndLot?.yearBuilt} />
          </Column>
          <Column>
            <DescriptionItem label="# of Buildings" value={buildingAndLot?.numberOfBuildings} />
          </Column>
        </Row>
        <Row>
          <Column>
            <DescriptionItem label="# of Stories" value={buildingAndLot?.stories} />
          </Column>
          <Column>
            <DescriptionItem label="Commercial Units" value={buildingAndLot?.commercialUnits} />
          </Column>
        </Row>
        <Row>
          <Column>
            <DescriptionItem label="Lot Sq. Footage" value={prettyNumber(buildingAndLot?.lotAreaSqFt)} />
          </Column>
          <Column>
            <DescriptionItem label="Lot Acreage" value={prettyNumber(buildingAndLot?.lotAreaAcre)} />
          </Column>
        </Row>
        <Row>
          <Column>
            <DescriptionItem label="Depth" value={buildingAndLot?.depth} />
          </Column>
          <Column>
            <DescriptionItem label="Frontage" value={buildingAndLot?.frontage} />
          </Column>
        </Row>
      </Content>
    </ModalCard>
  )
}
